import './components';
import './stores';

import isMobile from '../../auto/utils/isMobile';
import {
  makeCarousel,
  makeUnmountedCarousel,
} from '../../auto/utils/carousel/splide';
import serviceFactory from '../../auto/autoForceServiceFactory';
import { makeAllDdmOffersListSyncService } from '../../auto/services/DdmServiceV2/makeAllDdmOffersListSyncService';
import { DDMAdapter } from '../../auto/services/ddm_service/adapters/ddmAdapter';
import { addExceptionModelsToChannelData } from '../../auto/services/ddm_service/utils';
import DdmServiceV2 from '../../auto/services/DdmServiceV2/DdmServiceV2';
import fcaServiceApi from '../../auto/utils/fcaServiceApi';
import railsDateToChronometer from '../../auto/utils/railsDateToChronometer';
import { renderFeaturesDisplay } from '../../auto/utils/featuresDisplay';
import serviceConversionFactory from '../../auto/autoBoxOfficeServiceFactory';
import { offerShowEvents } from '../../auto/services/click_attacher_service/events/fiatEventsConfiguration';

window.makeCarousel = makeCarousel;
window.makeUnmountedCarousel = makeUnmountedCarousel;
window.railsDateToChronometer = railsDateToChronometer;
window.renderFeaturesDisplay = renderFeaturesDisplay;

window.isMobile = isMobile;
window.service = serviceFactory();
window.serviceConversion = serviceConversionFactory();

window.DDMAdapter = DDMAdapter;
window.autoServiceApi = DdmServiceV2; // API ofertas do Autódromo
window.serviceFca = fcaServiceApi; // API ofertas do marketplace
window.ddmOffersListSyncService = makeAllDdmOffersListSyncService();
window.helpers = {
  ...window.helpers,
  addExceptionModelsToChannelData,
};

window.attachClickEvents(window.DDMDataLayerService, [...offerShowEvents]);
